<template>
  <div class="ele-body">
    <el-card shadow="never">
      <el-row>
        <el-col :md="6" style="margin-bottom: 15px">
          <!-- 数据表格 -->
          <ele-data-table ref="gradeTable" :config="gradeTable" :current.sync="current" @done="gradeTableDone"
            highlight-current-row :height="tbHeight" class="dict-table">
            <el-table-column type="index" width="45" align="center" />
            <el-table-column prop="name" label="年级" show-overflow-tooltip />
          </ele-data-table>
        </el-col>
        <el-col :md="18" style="margin-bottom: 15px">
          <div class="ele-table-tool ele-table-tool-default">
            <el-button @click="addItem" type="primary" icon="el-icon-plus" class="ele-btn-icon"
              size="small">新增项目</el-button>
            <el-button @click="remove()" type="danger" icon="el-icon-setting" class="ele-btn-icon"
              size="small">批量删除</el-button>
          </div>
          <ele-data-table ref="table" :config="table" :choose.sync="choose" row-class-name="custom-row-class"
            highlight-current-row>
            <el-table-column type="selection" width="45" align="center" />
            <el-table-column prop="projectName" label="考核项目" show-overflow-tooltip align="center" />
            <el-table-column label="操作" align="center">
              <template #default="{ row }">
                <el-link @click="editItem(row)" icon="el-icon-edit" type="primary" :underline="false">编辑</el-link>
                <el-popconfirm title="确定要删除此项目？" @onConfirm="remove(row)" class="ele-action">
                  <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
                </el-popconfirm>
              </template>
            </el-table-column>
          </ele-data-table>
        </el-col>
      </el-row>
    </el-card>
    <!--添加修改考核项目-->
    <el-dialog :title="editForm.id ? '修改' : '添加'" :visible.sync="showEdit" width="450px" @closed="resetItemForm"
      :destroy-on-close="true" custom-class="ele-dialog-form" :lock-scroll="false">
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="100px">
        <el-form-item label="项目名称:" prop="projectName">
          <el-input v-model="editForm.projectName" placeholder="请输入项目名称" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit = false">取消</el-button>
        <el-button type="primary" @click="saveItem">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { delGradeAccessProject, saveGradeAccessProject } from '@/config/yizhongDong/examine';

export default {
  name: 'GradeProject',
  data () {
    return {
      table: {
        // 表格配置
        url: '/gradeAccess/gradeAccessProjectPage',
        method: 'GET',
        where: {
          gradeId: null,
        },
        parseData (res) {
          if (res.resCode == 200) res.code = 0;
          res.count = res.data.total;
          res.data = res.data.records;
          return res;
        },
      },
      choose: [],
      editForm: {
        type: 2,
        projectName: null,
      },
      editRules: {
        projectName: [{ required: true, message: '请输入项目名称', trigger: 'blur' }],
      },
      showEdit: false,
      gradeList: [],
      current: null, // 表格选中数据
      gradeTable: {
        // 年级列表
        url: '/gradeAccess/getGradeList',
        page: false,
        where: {},
        parseData (res) {
          if (res.resCode == 200) res.code = 0;
          return res;
        },
      },
    };
  },
  computed: {
    /* 表格固定高度 */
    tbHeight () {
      return this.$store.state.theme.screenWidth < 992 ? undefined : 'calc(100vh - 214px)';
    },
  },
  watch: {
    'current.id': {
      handler (newValue) {
        this.table.where.gradeId = newValue;
        this.editForm.gradeId = newValue;
        if (this.$refs.table) this.$refs.table.reload();
      },
    },
  },
  methods: {
    /* 表格渲染完成回调 */
    gradeTableDone (res) {
      this.gradeList = res.data || [];
      if (this.gradeList.length > 0) this.$refs.gradeTable.setCurrentRow(this.gradeList[0]);
    },
    // 添加考核项目
    addItem () {
      if (!this.current) return this.$message.error('请先选择年级');
      this.showEdit = true;
    },
    // 编辑考核项目
    editItem (row) {
      this.editForm = Object.assign({ type: 2 }, row);
      this.showEdit = true;
    },
    // 保存考核项目
    saveItem () {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({ lock: true });
          let formData = new FormData();
          for (let key in this.editForm) {
            if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
              formData.append(key, this.editForm[key]);
            }
          }
          saveGradeAccessProject(formData).then((res) => {
            loading.close();
            if (res.data.resCode == 200) {
              this.showEdit = false;
              this.$message({ type: 'success', message: res.data.resMsg });
              this.$refs.table.reload();
            } else {
              this.$message.error(res.data.resMsg);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 删除项目
    remove (row) {
      if (!row) {
        // 批量删除
        if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
        let ids = this.choose.map((d) => d.id);
        this.$confirm('确定要删除选中的项目吗?', '提示', { type: 'warning' }).then(() => {
          const loading = this.$loading({ lock: true });
          let formData = new FormData();
          formData.append('ids', ids);
          delGradeAccessProject(formData).then((res) => {
            loading.close();
            if (res.data.resCode == 200) {
              this.$message({ type: 'success', message: res.data.resMsg });
              this.$refs.table.reload();
            } else {
              this.$message.error(res.data.resMsg);
            }
          });
        });
      } else {
        const loading = this.$loading({ lock: true });
        let formData = new FormData();
        formData.append('ids', [row.id]);
        delGradeAccessProject(formData).then((res) => {
          loading.close();
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: res.data.resMsg });
            this.$refs.table.reload();
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      }
    },
    // 重置表单
    resetItemForm () {
      this.editForm = {
        type: 2,
        projectName: null,
        gradeId: this.current ? this.current.id : null,
      };
      this.$refs['editForm'].resetFields();
    },
  },
};
</script>

<style>
.custom-row-class {
  height: 50px !important;
}
</style>
